// Story timeline: show/hide timeline items beyond data-min-items
import $ from 'jquery';

export default function storyTimeline () {

	// store vars for toggling
	var hideClass = 'js-timeline__item--hidden';
	var hideAria = 'aria-hidden';

	$('.js-timeline').each(function(index) {
		var closed = true;
		var minItems = $(this).data('min-items');
		var items = $(this).find('.js-timeline__item').slice(minItems);
		var button = $(this).find('.js-timeline__button');
		var links = $(this).find('.js-timeline__content a');

		// add toggle handler
		button.on('click', function() {

			var labelMore = $(this).data('label-more');
			var labelFewer = $(this).data('label-fewer');

			// toggle open and closed
			if (closed) {
				closed = false;
				$(this)
				.text(labelFewer);
				items
				.removeClass(hideClass)
				.removeAttr(hideAria);
			}
			else {
				// calc offset to jump back to button position
				var offset = this.getBoundingClientRect().top;
				closed = true;
				$(this)
				.text(labelMore);
				items
				.addClass(hideClass)
				.attr(hideAria, true);
				$('html, body')
				.scrollTop($(this).offset().top - offset);
			}
		});

		// add handler for content links
		links.on('click', function(e) {
			e.preventDefault();
			var id = $(this).closest('.js-timeline__item').attr('id');
			history.pushState({ timelineId: id }, 'Timeline item');
			window.location = this.href;
		});

		// check for existing history state
		if (history.state && history.state.timelineId) {
			// check for matching item
			var item = $(this).find('#' + history.state.timelineId);
			if (item.length) {
				// clear the history state and scroll to top of matched item
				history.pushState(null, 'Timeline item');
				button.trigger('click');
				$('html, body')
				.scrollTop($(item).offset().top);
			}
		};

	});
}